import { render, staticRenderFns } from "./InjectText.vue?vue&type=template&id=6c8b5e18"
import script from "./InjectText.vue?vue&type=script&lang=js"
export * from "./InjectText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports